import { Model } from "@interfaces/model.interface";

export interface ToolHolder extends Model {
	isActive: boolean;
	name: string;
}

export class ToolHolder implements ToolHolder {
	isActive = true;
	name = "";

	constructor(data?: Partial<ToolHolder>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}
